import { useDataApiArticles, /*useDataApiArticlesByCategory,*/ useDataApiArticlesByCategoryBySpace } from "../../Hooks/useDataArticlesApi";
import { ArticleCrud } from "../../components/article/article";
// eslint-disable-next-line import/no-extraneous-dependencies
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-extraneous-dependencies
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

type ArticleRenderProperties = {
    isRestaurant: boolean;
    categoryId: number | undefined;
};

/**
 * @function ArticlesRender displays the complete week for the reservation page
 * @returns {JSX.Element} HTML content
 */

const ArticlesRender: React.FC<ArticleRenderProperties> = ({ isRestaurant, categoryId }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const articles = categoryId ? useDataApiArticles() : useDataApiArticlesByCategoryBySpace(4);

    return (
        <div className="bg-white overflow-x-auto flex flex-col gap-6 bg-white shadow-lg rounded-lg p-8">
            {
                isRestaurant ? undefined :
                    <>
                        <div className="flex justify-between">
                            <h2 className="text-2xl font-semibold py-2 px-4"> 
                                Liste des articles
                            </h2>
                            <Link to="/add-article">
                                <button
                                    disabled={articles === undefined}
                                    className={`${articles === undefined ? "animate-pulse bg-gray-300 p-5 rounded mt-2 disabled:cursor-not-allowed" : "rounded mt-2 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4"}`}
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                >
                                    {articles === undefined ? <>             </> : (
                                        <>
                                            <FontAwesomeIcon icon={faPlus} className="mr-2" /> Ajouter un article
                                        </>

                                    )}
                                </button>
                            </Link>
                        </div>
                    </>
            }
            {isRestaurant && 
                <h2 className="text-2xl font-semibold py-2 px-4"> 
                    Liste des restaurants
                </h2>
            }
            <table className="w-full table-auto">
                <thead>
                    <tr className="text-left">
                        <th className="p-4">Titre</th>
                        <th className="p-4">Image</th>

                        {
                            isRestaurant ? (<>
                                <th className="p-4">Contenu</th>

                            </>) : (<>
                                <th className="p-4">Publication</th>
                                <th className="p-4">Espace de Coworking</th>
                                <th className="p-4">Categorie de l'article</th>
                            </>)
                        }

                    </tr>
                </thead>
                <tbody className="w-full">
                    {articles === undefined ? (
                        <tr>
                            <td colSpan={7} className="text-center p-4">Chargement...</td>
                        </tr>
                    ) : (
                        articles.map((article) => (
                            <ArticleCrud
                                key={article.id}
                                {...article}
                                isRestaurant={isRestaurant}
                            />
                        ))
                    )}
                </tbody>
            </table>
        </div>

    );

}
export { ArticlesRender };